import React from 'react';
// import micIcon from 'assets/img/icons/mic.svg';

const IngredientSearch = props => {
  const { handleChange, handleCreateNewFood } = props;

  return (
    <div className="ingredient-search">
      <div className="form-group form-group-search">
        <input type="text" className="form-control" onChange={handleChange}/>
        <button className="search-btn">
          <i className="fas fa-search"></i>
        </button>
        {/* <button className="voice-btn">
          <img src={micIcon} />
        </button> */}
      </div>
      <div className="create-food">
        <p>Can’t find what you are looking for?</p>
        <button onClick={handleCreateNewFood} className="btn btn-primary btn-block">
          Create New Food
        </button>
      </div>
    </div>
  );
}

export default IngredientSearch;